import { DragDropModule } from '@angular/cdk/drag-drop';

import { ChangeDetectorRef, Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { ReleaseNote, ReleaseNoteMonth } from 'src/app/models/release-note';
import { RootStoreState } from 'src/app/root-store';
import { FormatComponent } from 'src/app/shared/base-components/format-component';
import { ReleaseNotePanelComponent } from 'src/app/shared/release-note-panel/release-note-panel.component';
import { SharedPipesModule } from 'src/app/shared/shared-pipes.module';

export interface ReleaseNotesModalData {
  releaseNotes: ReleaseNoteMonth[];
}

@Component({
  selector: 'app-release-notes-modal',
  templateUrl: './release-notes-modal.component.html',
  styleUrls: ['./release-notes-modal.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DragDropModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTableModule,
    MatToolbarModule,
    TranslatePipe,
    SharedPipesModule,
    ReleaseNotePanelComponent,
  ],
})
export class ReleaseNotesModalComponent extends FormatComponent implements OnInit {
  releaseNotes: ReleaseNoteMonth[];
  displayedColumnsTable: string[] = ['releasenote'];
  dataSourceTable: MatTableDataSource<ReleaseNoteMonth>;

  constructor(
    protected store: Store<RootStoreState.State>,
    protected cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<ReleaseNotesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReleaseNotesModalData,
  ) {
    super();
  }

  ngOnInit(): void {
    this.releaseNotes = this.data.releaseNotes;
    this.dataSourceTable = new MatTableDataSource(this.releaseNotes);
  }

  getMonthLabel(monthData: ReleaseNoteMonth): string {
    if (!monthData) {
      return '';
    }

    const monthDate = new Date(monthData.year, monthData.month - 1, 1);
    const monthName = monthDate.toLocaleString(this.translate.getCurrentLang(), { month: 'long' });
    return `${monthName} ${monthData.year}`;
  }

  trackMonth(index: number, monthData: ReleaseNoteMonth): number | string {
    return monthData?.entityId || `${monthData?.year}-${monthData?.month}-${index}`;
  }

  trackReleaseNote(index: number, releaseNote: ReleaseNote): number | string {
    return releaseNote?.entityId || releaseNote?.releasenoteId || index;
  }
}
